import React, { useEffect, useRef, useState } from "react";
import CanvasJSReact from "@canvasjs/react-charts";
import plane from "./assets/img/aviator.gif";
import loader from "./assets/img/loader.png";
import io from "socket.io-client";
import axios from "axios";


const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const Aviator = () => {
  const [multiplier, setMultiplier] = useState(0.5);
  const [isGameActive, setIsGameActive] = useState(false);
  const [finalMultiplier, setFinalMultiplier] = useState(null);
  const [delay, setDelay] = useState(null);
  const [roundStatus, setroundStatus] = useState(null);
  const userId = localStorage.getItem("_id");
  const [animationSpeed, setAnimationSpeed] = useState(0);

  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(100);

  const chartRef = useRef(null);
  const dps = useRef([]);
  const updateInterval = 300;
  let xVal = useRef(0);
  const MAX_DATA_POINTS = 100;

  const resetChart = () => {
    dps.current = [];
    xVal.current = 0;
    if (chartRef.current) {
      chartRef.current.chart.render();
    }
  };
  useEffect(() => {
    startGame();
    let hasCalledStatus = false;
    let hasCalledResultDataLoadStatus = false;
    // const ws = new WebSocket("http://localhost:5000");
     const ws = new WebSocket("https://avitorsocket.a2logicgroup.com/");

    ws.onopen = () => {
      console.log("Connected to WebSocket");

    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      switch (data.type) {
        case "gameStarting":
          setDelay(data.delay);
          // setRoundId(data.roundId);

          setroundStatus(data.roundStatus);
          break;
        case "multiplierUpdate":
          setMultiplier(data.multiplier);
          if (data.multiplier && !hasCalledResultDataLoadStatus) {
            hasCalledResultDataLoadStatus = true;
            // resultDataLoadStatus();
          }
          if (data.multiplier && !hasCalledStatus) {
            setroundStatus(data.roundStatus);
            hasCalledStatus = true;
          }
          break;
        case "gameCrash":
          setFinalMultiplier(data.finalMultiplier);

          if (data.finalMultiplier && hasCalledResultDataLoadStatus) {
            hasCalledResultDataLoadStatus = false;
            // resultDataLoadStatus();
            setroundStatus(data.roundStatus);
          }
          setFinalMultiplier(data.finalMultiplier);
          setTimeout(() => {
            setIsGameActive(false);
            setLoading(true);
            setFinalMultiplier("");
          }, 5000);

          hasCalledStatus = false;
          break;
        default:
          console.log("Unknown event type:", data.type);
      }
    };

    ws.onclose = () => {
      console.log("Disconnected from WebSocket");
    };

    return () => ws.close();
  }, []);

  const startGame = () => {
    // const ws = new WebSocket("http://localhost:5000");
     const ws = new WebSocket("https://avitorsocket.a2logicgroup.com/");
 
    ws.onopen = () => {
      ws.send(JSON.stringify({ type: "startGame" }));
    };
  };
  const resultDataLoadStatus = async () => {
    const _id = localStorage.getItem("_id");
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/bets/checkGameStatus`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          userId: userId,
          role: role,
        }
      );
     
      setroundStatus(response.data.roundStatus);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    resultDataLoadStatus();
  }, []);
  useEffect(() => {
    if (roundStatus === "start") {
      resetChart();
      setLoading(false);
      setProgress(100);
    }
  }, [roundStatus === "start"]);

  useEffect(() => {
    const updateChart = () => {
      if (chartRef.current && roundStatus === "start") {
        const chart = chartRef.current.chart;
        const yVal = xVal.current ** 2;
        dps.current.push({ x: xVal.current, y: yVal });

        if (dps.current.length > MAX_DATA_POINTS*MAX_DATA_POINTS*MAX_DATA_POINTS*MAX_DATA_POINTS) {
          dps.current.shift();
        }
        xVal.current = xVal.current  + 0.1;
        chart.options.data[0].dataPoints = dps.current;
        chart.render();
        positionMarkerImage(chart);
      }
    };
    const intervalId = setInterval(updateChart, updateInterval);
   
    return () => clearInterval(intervalId);
  }, [roundStatus === "start"]);

  const positionMarkerImage = (chart) => {
    const imageMarker = document.getElementById("marker");
    if (dps.current.length > 0) {
      const lastPoint = dps.current[dps.current.length - 1];
      const pixelX = chart.axisX[0].convertValueToPixel(lastPoint.x);
      // const pixelX = chart.axisX[0];
      const pixelY = chart.axisY[0].convertValueToPixel(lastPoint.y);
    
      imageMarker.style.display = "block";
      imageMarker.style.position = "absolute";
      imageMarker.style.top = `${pixelY - imageMarker.height / 2}px`;
      imageMarker.style.left = `${pixelX - imageMarker.width / 2}px`;
    }
  };


  
  const isMobile = window.innerWidth <= 768;
  const options = {
    title: {
      text: `${multiplier.toFixed(2)}X`,
      dockInsidePlotArea: true,
      verticalAlign: "center",
      fontSize: isMobile ? 50 : 100,
      color: "white",
    },
    backgroundColor: "transparent",
    animationEnabled: true,
    theme: "dark1",
    axisX: {
      minimum: 0, // Start x-axis at 0
      // maximum: MAX_DATA_POINTS, // Optional: Define a max value
      gridThickness: 0,
      tickLength: 0,
      labelFontSize: 20,
      labelFormatter: () => ".",
    },
    axisY: {
      minimum: 0, // Start y-axis at 0
      // maximum: MAX_DATA_POINTS * MAX_DATA_POINTS, // Adjust max y value if needed
      gridThickness: 0,
      tickLength: 0,
      margin: 10,
      lineThickness: 1,
      labelFontSize: 20,
      labelFormatter: () => ".",
    },
    data: [
      {
        type: "splineArea", 
        markerSize: 0,
        fillOpacity: 0.3,
        lineThickness: 5,
        color: "red",
        lineColor: "red",
        smooth: true, // Maintain smooth curve rendering
        dataPoints: dps.current,
      },
    ],
  };

  useEffect(() => {
    if (delay > 0) {
      setProgress(100);
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            setLoading(false);
            setDelay("");
            return 0;
          }
          return prev - 100 / ((delay * 10000) / 1000);
        });
      }, 100);

      return () => clearInterval(interval);
    }
  }, [delay * 1000, roundStatus === "active"]);

  return (
      <div className="mainAvi">
      {loading &&
        (roundStatus === "active" ||
          roundStatus === null ||
          roundStatus !== "start") && (
          <>
            <div className="innerAvi">
              <img src={loader} className="circleimage" />
              <h3>WAITING FOR NEXT ROUND</h3>
              <div className="process_bar">
              <div className="nextRound">
                <div
                  className="inprocess"
                  style={{
                    width: `${progress}%`,
                  }}
                />
              </div>
              </div>
            </div>
            <img
              // id="marker"
              src={plane}
              alt="marker"
              className="circleimageews"
            />
          </>
        )}

      {roundStatus === "start" &&
        (roundStatus !== null || roundStatus !== "active") && (
          <>
            <div className="flyer">
              <CanvasJSChart options={options} ref={chartRef} className="main_avi" />
              <img
                id="marker"
                src={plane}
                alt="marker"
              />
            </div>
          </>
        )}
      {!loading && finalMultiplier && (
        <>
          <div className="finalMulti">
            <h2 className="flew"> FLEW AWAY!</h2>
            <h1 className="finalMultipliers ">{finalMultiplier.toFixed(2)}X</h1>
          </div>
        </>
      )}      
    </div>
   
  );
};

export default Aviator;
